import { useState } from "react"
import styles from "./live-stream-page.module.css"
import LiveStreamViewer from "./Live/LiveStreamViewer"
import TournamentInfo from "./Live/TournamentInfo"
import StreamChat from "./Live/StreamChat"
import { useParams } from "react-router-dom"

// Mock data - replace with actual data fetching
const mockTournaments = {
    1: {
        id: 1,
        game: "Mobile Legends: Bang Bang",
        gameName: "MLBB",
        tournamentName: "Pro League Season 5",
        team1: "Phoenix Rising",
        team2: "Dragon Slayers",
        status: "live",
        viewers: 12500,
        streamUrl: "/statics/mobile-legends-esports-match-gameplay.jpg",
        startTime: "2025-10-22T18:00:00",
        prizePool: "₹50,000",
        format: "5v5",
    },
    2: {
        id: 2,
        game: "Valorant",
        gameName: "Valorant",
        tournamentName: "Champions Cup 2025",
        team1: "Sentinels",
        team2: "FaZe Clan",
        status: "live",
        viewers: 25000,
        streamUrl: "/statics/valorant-esports-competitive-match.jpg",
        startTime: "2025-10-22T19:30:00",
        prizePool: "₹1,00,000",
        format: "5v5",
    },
    3: {
        id: 3,
        game: "PUBG Mobile",
        gameName: "PUBG",
        tournamentName: "Global Championship",
        team1: "Team Liquid",
        team2: "Nova Esports",
        status: "live",
        viewers: 18000,
        streamUrl: "/statics/pubg-mobile-battle-royale-esports.jpg",
        startTime: "2025-10-22T20:00:00",
        prizePool: "₹75,000",
        format: "4v4",
    },
}

export default function LiveStreamPage() {
    const {streamId} = useParams();
    const tournament = mockTournaments[streamId]
    const [messages, setMessages] = useState([
        { id: 1, user: "ProGamer123", message: "Amazing play!", timestamp: "18:05" },
        { id: 2, user: "EsportsLover", message: "This tournament is insane 🔥", timestamp: "18:06" },
        { id: 3, user: "PixelMoonFan", message: "Go Phoenix Rising!", timestamp: "18:07" },
    ])

    const handleSendMessage = (message) => {
        setMessages([
            ...messages,
            {
                id: messages.length + 1,
                user: "You",
                message,
                timestamp: new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }),
            },
        ])
    }

    if (!tournament) {
        return <div className={styles.notFound}>Tournament not found</div>
    }

    const autoTitle = `${tournament.gameName} - ${tournament.tournamentName} - ${tournament.team1} vs ${tournament.team2}`

    return (
        <div className={styles.liveDetailContainer}>
            <div className={styles.mainContent}>
                <LiveStreamViewer tournament={tournament} autoTitle={autoTitle} />
                <TournamentInfo tournament={tournament} />
            </div>

            <div className={styles.chatSidebar}>
                <StreamChat messages={messages} onSendMessage={handleSendMessage} />
            </div>
        </div>
    )
}
